// src/hooks/nationalities/useRestoreAllNationalities.js
import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { restoreAllNationalities as restoreAllNationalitiesAPI } from "../../api/apiNationalities";
import parseError from "../../utils/parseError";

const useRestoreAllNationalities = () => {
    const queryClient = useQueryClient();

    const { mutate: restoreAll, isPending: isRestoreAll } = useMutation({
        mutationFn: restoreAllNationalitiesAPI,
        onSuccess: (res) => {
            const message = res?.message || "Selected nationalities restored successfully";
            toast.success(message);
            queryClient.invalidateQueries({ queryKey: ["nationalities"] });
        },
        onError: (error) => {
            const msg = parseError(error);
            toast.error(msg || "Failed to restore selected nationalities");
        },
    });

    return { restoreAllNationalities: restoreAll, isRestoreAll };
};

export default useRestoreAllNationalities;